import React, { useEffect } from "react";
import Head from "components/Head";
import useProvidersSuccess from "../../hooks/useProvidersSuccess";
import Auth from "components/Auth";

export default function ProfileConnectSuccess(props) {
  const { redirectTo } = useProvidersSuccess();
  useEffect(() => {
    if (!!redirectTo) {
      window.location.href = redirectTo;
    }
  }, [redirectTo]);

  return (
    <>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>
      <Auth />
    </>
  );
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
